import api from "../index"

const investorAuthApi = api.injectEndpoints({
  endpoints: (build) => ({
    investorLogin: build.mutation({
      query: (params) => ({
        url: `/investor/auth/login`,
        method: "POST",
        body: params,
      }),
    }),
    investorRegister: build.mutation({
      query: (params) => ({
        url: `/investor/auth/register`,
        method: "POST",
        body: params,
      }),
    }),
    investorVerifyLoginOTP: build.mutation({
      query: (params) => ({
        url: `/investor/auth/verify/otp`,
        method: "POST",
        body: params,
      }),
    }),
    investorResendOTP: build.mutation({
      query: (params) => ({
        url: `/investor/auth/resend/otp`,
        method: "POST",
        body: params,
      }),
    }),
    investorForgotPassword: build.mutation({
      query: (params) => ({
        url: `/investor/auth/forgot-password`,
        method: "POST",
        body: params,
      }),
    }),
    investorResetPassword: build.mutation({
      query: (params) => ({
        url: `/investor/auth/reset-password`,
        method: "POST",
        body: params,
      }),
    }),
    investorProfileUpdate: build.mutation({
      query: (image) => {
        const formData = new FormData()
        formData.append("image", image)
        return {
          url: `/profile/investor/upload-image`,
          method: "POST",
          body: formData,
        }
      },
    }),
    whealthProfileUpdate: build.mutation({
      query: (image) => {
        const formData = new FormData()
        formData.append("image", image)
        return {
          url: `/profile/whealth-partner/upload-image`,
          method: "POST",
          body: formData,
        }
      },
    }),
    investorUpdatePassword: build.mutation({
      query: (params) => ({
        url: `/profile/investor/change-password`,
        method: "PUT",
        body: params,
      }),
    }),
    investorUpdateWpAccess: build.mutation({
      query: (params) => ({
        url: `/profile/investor/update/wp/access`,
        method: "PUT",
        body: params,
      }),
    }),
    getInvestorProfile: build.query({
      query: () => ({
        url: `/profile/investor/profile`,
        method: "GET",
      }),
    }),
    deleteAccountInvestor: build.mutation({
      query: (params) => ({
        url: `/profile/investor/delete-account`,
        method: "POST",
        body: params,
      }),
    }),
    deleteAccountWealthPartner: build.mutation({
      query: (params) => ({
        url: `/profile/wealth-partner/delete-account`,
        method: "POST",
        body: params,
      }),
    }),

    investorGlobalSeach: build.query({
      query: ({ query }) => ({
        url: `/investor/content/search?q=${query}`,
        method: "GET",
      }),
    }),

    wpGlobalSeach: build.query({
      query: ({ query }) => ({
        url: `/wealthPartner/content/search?q=${query}`,
        method: "GET",
      }),
    }),

    getNotifications: build.query({
      query: () => ({
        url: `/notification`,
        method: "GET",
      }),
    }),

    getAllNotifications: build.query({
      query: (params) => ({
        url: `/notification/all`,
        method: "GET",
        params,
      }),
    }),
  }),
})

export const {
  useInvestorLoginMutation,
  useInvestorRegisterMutation,
  useInvestorVerifyLoginOTPMutation,
  useInvestorResendOTPMutation,
  useInvestorForgotPasswordMutation,
  useInvestorResetPasswordMutation,
  useInvestorProfileUpdateMutation,
  useWhealthProfileUpdateMutation,
  useInvestorUpdatePasswordMutation,
  useLazyGetInvestorProfileQuery,
  useLazyInvestorGlobalSeachQuery,
  useLazyWpGlobalSeachQuery,
  useDeleteAccountInvestorMutation,
  useDeleteAccountWealthPartnerMutation,
  useLazyGetNotificationsQuery,
  useLazyGetAllNotificationsQuery,
  useInvestorUpdateWpAccessMutation,
} = investorAuthApi
